var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgWarning = function SvgWarning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 17
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1055 -2171)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 297"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 989",
    d: "M1065.091 2172.274c-.876-1.7-2.308-1.7-3.184 0l-6.534 12.648c-.874 1.699-.159 3.08 1.592 3.08h13.069c1.751 0 2.467-1.388 1.592-3.078z"
  })), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2118",
    width: 7,
    height: 2,
    rx: 1,
    transform: "rotate(90 -555.5 1620)"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 2119",
    width: 2,
    height: 2,
    rx: 1,
    transform: "rotate(90 -559.5 1624)"
  }))));
};

export default SvgWarning;